<template>
  <el-dialog 
    :title="$t('serviceImplManage.editServiceImpl')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog">
    <el-form :model="editServiceImplInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('serviceImplManage.businessName')" prop="name">
        <el-input 
          v-model="editServiceImplInfo.name" 
          :placeholder="$t('serviceImplManage.requiredBusinessName')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.invokeType')" prop="invokeType">
        <el-select 
          v-model="editServiceImplInfo.invokeType" 
          style="width:100%"
          :placeholder="$t('serviceImplManage.requiredInvokeType')">
          <el-option disabled value="">{{$t('serviceImplManage.requiredInvokeType')}}</el-option>
          <el-option value="1">{{$t('serviceImplManage.microservicePost')}}</el-option>
          <el-option value="2">{{$t('serviceImplManage.webservice')}}</el-option>
          <el-option value="3">{{$t('serviceImplManage.httpPost')}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.invokeUrl')" prop="url">
        <el-input 
          v-model="editServiceImplInfo.url" 
          :placeholder="$t('serviceImplManage.requiredInvokeUrl')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.kafkaTopic')">
        <el-input 
          v-model="editServiceImplInfo.messageTopic" 
          :placeholder="$t('serviceImplManage.optionalKafkaTopic')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.timeout')" prop="timeout">
        <el-input 
          v-model="editServiceImplInfo.timeout" 
          :placeholder="$t('serviceImplManage.requiredTimeout')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.retryCount')" prop="retryCount">
        <el-input 
          v-model="editServiceImplInfo.retryCount" 
          :placeholder="$t('serviceImplManage.requiredRetryCount')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.description')">
        <el-input 
          type="textarea" 
          v-model="editServiceImplInfo.description" 
          :placeholder="$t('serviceImplManage.optionalDescription')">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="editServiceImpl">{{$t('common.save')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateServiceImpl } from '@/api/dev/serviceImplApi'

export default {
  name: 'EditServiceImpl',
  data() {
    return {
      dialogVisible: false,
      editServiceImplInfo: {
        serviceBusinessId: '',
        name: '',
        invokeType: '',
        url: '',
        messageTopic: '',
        timeout: '60',
        retryCount: '3',
        description: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('serviceImplManage.requiredBusinessName'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('serviceImplManage.businessNameLength'), trigger: 'blur' }
        ],
        invokeType: [
          { required: true, message: this.$t('serviceImplManage.requiredInvokeType'), trigger: 'change' }
        ],
        url: [
          { required: true, message: this.$t('serviceImplManage.requiredInvokeUrl'), trigger: 'blur' },
          { max: 200, message: this.$t('serviceImplManage.invokeUrlLength'), trigger: 'blur' }
        ],
        timeout: [
          { required: true, message: this.$t('serviceImplManage.requiredTimeout'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('serviceImplManage.timeoutNumber'), trigger: 'blur' }
        ],
        retryCount: [
          { required: true, message: this.$t('serviceImplManage.requiredRetryCount'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('serviceImplManage.retryCountNumber'), trigger: 'blur' }
        ],
        messageTopic: [
          { max: 50, message: this.$t('serviceImplManage.kafkaTopicLength'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('serviceImplManage.descriptionLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(serviceImpl) {
      this.editServiceImplInfo = { ...serviceImpl }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    editServiceImpl() {
      this.$refs.form.validate(valid => {
        if (valid) {
          updateServiceImpl(this.editServiceImplInfo).then(() => {
            this.$message.success(this.$t('common.saveSuccess'))
            this.$emit('success')
            this.closeDialog()
          }).catch(err => {
            console.error(err)
          })
        }
      })
    }
  }
}
</script>